<div class="title-wrapper">
    <button class="sidebar-toggle" (click)="leftSidebarService.toggleSidebar()"></button>
    <div class="title"><span>ev</span>Kart</div>
    <!--  -->
    @if(!expand) { 
    <a
        class="search-icon"
        (click)="openSearch()"
    ></a>
    }
</div>
@if(expand) {
<div class="multi-search-wrapper" [ngClass]="{'multisearch': searchMode === SearchModeEnum.MULTISEARCH, 'owner': searchMode === SearchModeEnum.OWNERSEARCH, 'customercheck': searchMode === SearchModeEnum.CUSTOMERCHECK, 'appraisal': searchMode === SearchModeEnum.APPRAISALSEARCH }">
    <ev-multi-search [forceShortNames]="true" (close)="expand = false" (searchMode)="searchChange($event)"></ev-multi-search>
</div>
<div class="search-guide-wrapper">
    <search-guide [searchMode]="searchMode" [theme]="'map'"></search-guide>
</div>
}
